<template>
    <v-form :disabled="isEditableForm">
        <v-row>
            <v-col md="12">
                <v-card>
                    <v-dialog
                        transition="dialog-top-transition"
                        max-width="600"
                        v-model="isOpenDialog"
                        persistent
                    >
                        <v-card elevation="0" class="pa-4">
                            <v-row>
                                <v-col md="12">
                                    <h1 class="font-weight-light primary--text">
                                        Origen BD
                                    </h1>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    :class="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'pa-5'
                                            : ''
                                    "
                                >
                                    <v-card
                                        elevation="0"
                                        :class="
                                            !$vuetify.breakpoint.smAndDown
                                                ? 'px-4'
                                                : 'pa-px-0'
                                        "
                                    >
                                        <!-- <v-row>
                                            <v-col md="12" class="mb-1 mt-1">
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Datos
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider> -->
                                        <v-row class="mb-n7">
                                            <v-col
                                                :cols="
                                                    $vuetify.breakpoint
                                                        .smAndDown
                                                        ? '12'
                                                        : '6'
                                                "
                                                :class="
                                                    $vuetify.breakpoint
                                                        .smAndDown
                                                        ? 'pa-5 py-2'
                                                        : 'pa-1'
                                                "
                                            >
                                                <v-text-field
                                                    v-model="Name"
                                                    label="Nombre"
                                                    :style="
                                                        $vuetify.breakpoint
                                                            .smAndDown
                                                            ? ''
                                                            : 'padding: 21.1px 0px 17px 0px'
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                :cols="
                                                    $vuetify.breakpoint
                                                        .smAndDown
                                                        ? '12'
                                                        : '6'
                                                "
                                                :class="
                                                    $vuetify.breakpoint
                                                        .smAndDown
                                                        ? 'pa-5 py-2'
                                                        : 'pa-1'
                                                "
                                            >
                                                <v-text-field
                                                    v-model="Timestamp"
                                                    label="Timestamp"
                                                    disabled
                                                    style="
                                                        padding: 21.1px 0px 17px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-card-actions class="justify-end mb-n4 mr-n6">
                                <v-btn
                                    depressed
                                    color="success"
                                    @click="submitOrigin"
                                    v-if="!isEditableForm"
                                >
                                    Guardar
                                </v-btn>
                                <v-btn text color="red" @click="closeForm">
                                    Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
export default {
    name: 'dboriginManagementForm',
    data: () => ({}),
    methods: {
        clearFields() {
            this.$store.state.ManagementBase.dboriginManagement.Name = '';
            this.$store.state.ManagementBase.dboriginManagement.Timestamp = '';
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/dboriginManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitOrigin() {
            if (
                this.$store.state.ManagementBase.dboriginManagement.formType ==
                'add'
            )
                this.$store.dispatch(
                    'ManagementBase/dboriginManagement/addOrigin'
                );
            else
                this.$store.dispatch(
                    'ManagementBase/dboriginManagement/editOrigin'
                );

            this.closeForm();
        },
    },
    computed: {
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.dboriginManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/dboriginManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        Name: {
            get() {
                return this.$store.state.ManagementBase.dboriginManagement.Name;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/dboriginManagement/Name',
                    val
                );
            },
        },
        Timestamp: {
            get() {
                return this.$store.state.ManagementBase.dboriginManagement
                    .Timestamp;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/dboriginManagement/Timestamp',
                    val
                );
            },
        },
        isEditableForm: {
            get() {
                return this.$store.state.ManagementBase.dboriginManagement
                    .isEditableForm;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/dboriginManagement/isEditableForm',
                    val
                );
            },
        },
    },
};
</script>
